import React from 'react';
import { useQuery } from '@apollo/client';
import { useWindowWidth } from '@react-hook/window-size';
import UpperFunnelToaster from './UpperFunnelToaster';
import UpperFunnelLoginMobileContent from './UpperFunnelLoginMobileContent';
import { ERROR_MESSAGE } from '../Messages/Messages';
import { TmntHtml } from '../Common';
import { UPPER_FUNNEL_CONTENT_QUERY } from './operations';

export default function UpperFunnelLogin() {
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 768;

  const { loading, error, data } = useQuery(UPPER_FUNNEL_CONTENT_QUERY);
  const { textFor } = data || {};

  if (loading) return null;
  if (error) return ERROR_MESSAGE;

  return (
    <UpperFunnelToaster>
      <div className="upperfunnel-content">
        {
          !isMobile
            ? <TmntHtml tmnt={textFor?.upperFunnelToasterContent} />
            : <UpperFunnelLoginMobileContent />
        }
      </div>
    </UpperFunnelToaster>
  );
}
